export default ({...props}) => {
  const {space, size, unit} = props.theme
  return `
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    flex-direction: column;
    & > div.subHeader {
      display: flex;
      align-items: flex-start;
      gap: ${space(1)}px;
      padding: ${space(1)}px  ${space(1)}px ${space(1)}px 0;
      min-width: ${size(3)}px;
      & > div[ap_atom_name="svgIconAtom"] {
        min-width: ${size(3)}px;
        position: relative;
        top: ${space(0.1)}px;
        display: -webkit-box;
        > svg {
          width: ${size(12.5)}%;
        }
      }
    }

    & > div.slots-wrapper {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      flex-grow: 2;
      justify-content: space-between;

      & div.fieldset-wrapper {
        display: flex;
        flex-wrap: wrap;
        width: ${size(12.5)}%;
        max-height: ${unit(38)}vh;
        overflow-y: auto;
        margin-bottom: ${space(2)}px;
        @media screen and (max-width: 769px)  {
          max-height: calc(${size(10)}vh - ${size(22.5)}px);
        }
        > fieldset {
          display: flex;
          flex-wrap: wrap;
          > [ap_atom_name="buttonDateTimeslotAtom"] {
            display: flex;
            flex-wrap: wrap;
            overflow: auto;
          }
        }

        @-moz-document url-prefix() {
          scrollbar-width: thin;
          scrollbar-color: #d6dee1 transparent;
          padding-right: ${space(1)}px;
        }
      
        ::-webkit-scrollbar {
          width: ${size(2)}px;
        }
        
        ::-webkit-scrollbar-track {
          background-color: transparent;
        }
        
        ::-webkit-scrollbar-thumb {
          background-color: #d6dee1;
          border-radius: ${space(2)}px;
          border: 4px solid transparent;
          background-clip: content-box;
        }

      }

      [ap_atom_name="apDateSelectionActionBtnWrapperAtom"]{
        flex-grow: 1;
      }

      .date-slot-actions{
        display: flex;
        flex-wrap: wrap;
        max-height: ${size(10.625)}px;
      }

      & [ap_atom_name="buttonDateTimeslotAtom"] p {
        text-transform: capitalize;
      }

      & > button {
        height: ${size(6.625)}px;
        text-transform: lowercase;
      }
    }

    @media only screen 
    and (min-device-width: 390px) 
    and (max-device-width: 736px) 
    and (-webkit-min-device-pixel-ratio: 2) 
    and (orientation: portrait) {
      & > div.slots-wrapper {
        & div.fieldset-wrapper {
          width: ${size(12.5)}%;
          max-height: calc(${size(12.5)}vh - ${size(50)}px);
          overflow-y: auto;
          margin-bottom: ${0}px;
        }
        > [ap_type="secondary"]{
          box-shadow: 0px -10px 0px 0px white;
        }
      }
    }
    @media only screen 
    and (min-device-width: 360px) 
    and (max-device-width: 389px) 
    and (-webkit-min-device-pixel-ratio: 2) 
    and (orientation: portrait) {
      & > div.slots-wrapper {
        & div.fieldset-wrapper {
          width: ${size(12.5)}%;
          max-height: calc(${size(12.5)}vh - ${size(50)}px);
          overflow-y: auto;
          margin-bottom: ${0}px;
        }
        > [ap_type="secondary"]{
          box-shadow: 0px -10px 0px 0px white;
        }
      }
    }

  `
}

// max-height: calc(${size(10)}vh - ${size(39.375)}px);
//         @media screen and (max-width: 501px) {
//           max-height: calc(${size(12.5)}vh - ${size(52)}px);
//         }

//         @media screen and (max-width: 321px) {
//           max-height: calc(${size(12.5)}vh - ${size(50.625)}px);
//         }

// @media screen and (max-width: 768px) {
//   padding-top: 0px;
// }

// max-width: ${size(46.25)}px;
